export function showPayment(user) {

  // User has paid
  if (user.payment && user.payment.duration > 0)  {
    return false
  }

  // User is in trial
  // check if trial is expired, if so update localStorage
  // show payment
  if (JSON.parse(localStorage.isTry) === true) {

    const ts = Date.parse(localStorage.trialStart)
    const now = new Date()
    const diff = (now - ts)

    console.log("trial age ms: ",diff)

    if ( ( diff / 1200000) > 23 ) {
      localStorage.isTry = false
      return true
    }
    return false
  }

  // User has not paid
  if (user.payment && user.payment.duration == 0 ) {
    return true
  }

  // default to show payment
  return true

}



// WEBPACK FOOTER //
// ./src/utils/misc.js